<template>

<v-card v-if="hub" @click="select(hub)" v-bind="$attrs" min-height="50" 
:disableds="!allowOrder && !search">
       <v-hover
                                v-slot="{ hover }"
                              >
              <v-img 
              :src="banner" 
                class="white--text py-3 align-center text-center pb-3"
                :gradients="hover? getGradient(color) : getGradient('#000000')"
               height="130"
              >
              <eetplein>
               <div class="d-flex eetplein-header"> {{hub.name}} <v-icon v-if="favorite" small :color="dark? null : 'primary'" class="ml-2">favorite</v-icon></div>
                <div class="float-right">
                <v-chip color="transparent" v-if="hub._subs && hub._subs.length==1" class="white--text px-0 pt-1 eetplein-subheader" style="height:auto;">1 Eetplein</v-chip>
                <v-chip color="transparent" v-else-if="hub._subs && hub._subs.length>1" class="white--text px-0 pt-1 eetplein-subheader" style="height:auto;">{{hub._subs.length}} Eetpleinen</v-chip>
                <!--v-chip color="transparent" v-else-if="hub._hosts && hub._hosts.length==1" class="white--text px-0 pt-1 eetplein-subheader" style="height:auto;">1 Eetzaak</v-chip>
                <v-chip color="transparent" v-else-if="hub._hosts && hub._hosts.length>1" class="white--text px-0 pt-1 eetplein-subheader" style="height:auto;">{{hub._hosts.length}} Eetzaken</v-chip-->
                </div>
              </eetplein>
                <slot></slot>
            </v-img>
       </v-hover>
       <template v-if="showInfo">
       <v-card-text v-if="hub.description" v-html="description" @click.stop="viewMore=!viewMore"></v-card-text>
      <v-card-text v-else-if="hub.region && hub.region.join" v-text="hub.region.join(', ')"></v-card-text>
       </template>
  </v-card>
                                            
</template>
<script>
import cardItem from '@/modules/cardItem'
import timeTable from '@/modules/timeTable'
import externalLink from '@/components/externalLink'
import Eetplein from "@/components/Eetplein";
export default {
  mixins: [cardItem, timeTable],
   components:{externalLink, Eetplein},
   props: {
    value: {
      type: Object,
      default: function () {
        return null
      },
    },
    distance: {
        type: Number,
        default: function () {
          return null
        },
      },
      dark:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      deliver:{
        type: Boolean,
        default: function () {
          return false
        },
      },
       search:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      showInfo:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      isFavorite:{
        type: Boolean,
        default: function () {
          return false
        },
      },
   },
  data: () => ({
     viewMore:false
  }),
  computed: {
    favorite:{
      get(){
        return this.hub._favorite || this.isFavorite
      },
      set(value){
        this.hub._favorite = value
      }
    },
    banner(){
      //return '/bg-card.png'
      return this.hub.banner || '/bg-card.png'
    },
    color(){
      if (this.hub.color && this.hub.color.includes('#')) return this.hub.color 
      if (!this.hub.type || !this.hub.type[0]) return '#000000'
      return this._config('menu',this.hub.type[0]).color || '#000000'
    },
    description(){
      if (!this.hub.description) return null
      if (!this.viewMore) {
        let d = this.hub.description.slice(0, 100)
        if (d.length==200) d += ' <b>...</b>'
        return d
      }
      return this.hub.description.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    hub: {
        get: function() {
          return this.value;
        },
        set: function(value) {
          this.$emit('input', value)
        }
    },
    
  },
  mounted () {

  },
watch: {

},
methods: {
   select(hub){
     this.$emit('select', hub)
    //this.setHost(hub)
    //this.$router.push({'path' : "/" + hub._id})
  },
  goto(hub){
    this.$router.push({'path' : "/" + hub._id})
  },
  },

}

</script>
